import { render, staticRenderFns } from "./MainFooter.vue?vue&type=template&id=59f6a0f3"
import script from "./MainFooter.vue?vue&type=script&lang=js"
export * from "./MainFooter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports